import Head from "next/head";
import dynamic from "next/dynamic";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { getClientIp } from "utils/requestHelpers";
import { handleRateLimit } from "utils/handleRateLimit";

const LandingPage = dynamic(() => import("../js/Components/LandingPages/LandingPage"));

//Dynamically load the home component and return it
const venue = ({ data }) => {
    const meta = data.template_page_content.meta;
    return (
        <>
            <Head>
                <title>{meta.meta_title}</title>
                <meta
                    name="description"
                    content={meta.meta_description}
                />
            </Head>
            <PageContextWrapper
                page='landing'
                page_content={data.template_page_content}
            >
                <LandingPage {...data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ req, res, query }) {
    const { headers } = getClientIp(req);

    try {
        const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-landing-page?page=venue`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            }
        };

    } catch (error) {
        return { notFound: true }
    }
}
// export async function getStaticProps({ query, res }) {
//     try {
//         const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-landing-page?page=venue`);
//         const data = await req.json()

//         if(data.exception) {
//             return {notFound: true}
//         }

//         return {
//             props: {
//                 data
//              },
//         };

//     } catch (error) {
//         return {notFound: true} //404
//     }
// }

export default venue;
